<template>
  <div>
    <font-awesome-icon :icon="['fas',[statusVoltage.icon]]" :class="[statusVoltage.color]" />
    <span
      class="text"
    >{{$t('report.voltage')}}: {{voltage + ' V '}}</span>
  </div>
</template>

<script>
    export default {
      name: "VoltageResultComponent",
      props: ['voltage'],
      data() {
        return {
          voltageStatusMap: [
            {
              min: 12.5,
              max: 1000,
              status: {
                condition: 'report.goodCondition',
                color: 'green-icon',
                icon: 'check-circle'
              }
            },
            {
              min: 12.4,
              max: 12.49,
              status: {
                condition: 'testResult.diagnosisAverage',
                color: 'yellow-icon',
                icon: 'check-circle'
              }
            },
            {
              min: 1,
              max: 12.39,
              status: {
                condition: 'report.badCondition',
                color: 'red-icon',
                icon: 'times-circle'
              }
            }
          ]
        }
      },
      computed: {
          statusVoltage: function() {
            let voltageStatus = null;
            this.voltageStatusMap.forEach(item => {
              if (
                parseFloat(this.voltage) >= item.min &&
                parseFloat(this.voltage) <= item.max
              ) {
                voltageStatus = item.status;
              }
            });
            return voltageStatus;
          }
        }
    }
</script>

<style scoped lang="scss">
@import '~@/styles/variables';

svg {
  margin-right: 15px;
}

.red-icon {
  color: $red;
}

.green-icon {
  color: $green;
}

.yellow-icon {
  color: $orange;
}

.blue-icon {
  color: $primary;
}
</style>
